import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=4937b7fe&scoped=true&lang=pug"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"
import style0 from "./Manage.vue?vue&type=style&index=0&id=4937b7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937b7fe",
  null
  
)

export default component.exports